import React, {useEffect, useState} from 'react';
import {EdgeBuilderProvider} from "./association-network-context.jsx";
import AssociationNetworkForm from "./association-network-form.jsx";
import {useParams} from "react-router";
import {ReactFlowProvider} from "@xyflow/react";

const AssociationNetworkInit = () => {
    const {id} = useParams()

    const searchParams = new URLSearchParams(window.location.search);
    const cpf = searchParams.get("cpf");
    const passage = searchParams.get("passage");
    const plate = searchParams.get("plate");

    return (
        <EdgeBuilderProvider id={id}>
            <ReactFlowProvider>
                <AssociationNetworkForm id={id} cpf={cpf} passage={passage} plate={plate}/>
            </ReactFlowProvider>
        </EdgeBuilderProvider>
    );
};

export default AssociationNetworkInit;